import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { IndentReceiveDetails } from './IndentReceiveDetails';

export interface IndentReceiveHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface IndentReceiveHeader { 

    id?:number;
    indentGrnDate:any;
    receivedBy:string;
    senderTenantId:string;
    senderBranchId:string;
    senderDepartmentId:string;
    receiverTenantId:string;
    receiverBranchId:string;
    receiverDepartmentId?:string;
    createdBy:string;
    createdDate:any;
    branchId: string;
    tenantId: string;  
    internalDepartmentId:any;
    pharmacyId:any;
    phIndentGRNDetDto: IndentReceiveDetails[];
    indentType?: string | null;
    senderLocationId?: number | null;
    phStockAndAdjDet?: Record<string,Array<any>> | null;
    
    parameters?: IndentReceiveHeaderParameter[];
    links?: any;
    indentIssueId?:number;
}


export abstract class IndentReceiveHeaderData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<IndentReceiveHeader[]>;
    abstract create(url: string, data: IndentReceiveHeader): Observable<IndentReceiveHeader[]>;
    abstract update(url: string, data: IndentReceiveHeader): Observable<IndentReceiveHeader>;
}
